import { deleteRequest } from '@/core';
import { tripAddresses } from '@/requests';
export default async function deleteTripAddressRequest(idToDelete) {
	let url = tripAddresses.getByIdPath(idToDelete);
	return deleteRequest(url);
}